import { memo } from 'react';

import CalculationIconV1 from './assets/CalculationIconV1';
import InputIconV1 from './assets/InputIconV1';

interface BuilderModeV1IndicatorIconProperties {
  indicatorType: string | undefined;
  size?: number;
}

/** Input/calculation icons for Builder Mode V1 tables only. */
const BuilderModeV1IndicatorIcon = memo(
  ({ indicatorType, size = 15 }: BuilderModeV1IndicatorIconProperties) => {
    const normalizedType = indicatorType?.toLowerCase() ?? '';

    if (normalizedType === 'calculation') {
      return <CalculationIconV1 size={size} />;
    }

    if (normalizedType === 'input') {
      return <InputIconV1 size={size} />;
    }

    return null;
  },
);

BuilderModeV1IndicatorIcon.displayName = 'BuilderModeV1IndicatorIcon';

export default BuilderModeV1IndicatorIcon;
